import { Program } from "../../../models/ISchema";

type IOption = {
  label: string;
  value: string;
};

/**
 * Filters programs by applying cascading criteria: campus, department, modality, shift, and program.
 * Campus is optional — when provided, programs are pre-filtered by campus before applying other filters.
 * Each subsequent filter is only applied if its corresponding value is present.
 */
export const getSelectablePrograms = (
  programs: Program[],
  campus: IOption,
  department: IOption,
  modality: IOption,
  shift: IOption,
  program: IOption,
) => {
  let selectablePrograms: Program[] = [];
  if (department?.value) {
    selectablePrograms = programs.filter(item => {
      const matchCampus = campus?.value ? item?.campus?.id === campus?.value : true;
      return matchCampus && item?.department?.id === department?.value;
    });
    if (modality?.value) {
      selectablePrograms = selectablePrograms.filter(item =>
        department ? item.modality.id === modality.value : false,
      );
    }
    if (shift?.value) {
      selectablePrograms = selectablePrograms.filter(item =>
        department ? item.shift.id === shift.value : false,
      );
    }
    if (program?.value) {
      selectablePrograms = selectablePrograms.filter(item =>
        department ? item.id === program.value : false,
      );
    }
  }
  return selectablePrograms;
};
